function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function sortObject(obj) {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(sortObject).sort(function(a, b) {
            return JSON.stringify(a).localeCompare(JSON.stringify(b));
        });
    }
    var sortedKeys = Object.keys(obj).sort();
    var result = {};
    for(var _i = 0; _i < sortedKeys.length; _i++){
        var key = sortedKeys[_i];
        result[key] = sortObject(obj[key]);
    }
    return result;
}
function stringifyAndCompare(obj1, obj2) {
    var sortedObj1 = JSON.stringify(sortObject(obj1));
    var sortedObj2 = JSON.stringify(sortObject(obj2));
    return sortedObj1 === sortedObj2;
}
function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function mergeObjects(obj1, obj2) {
    if (!isObject(obj1) || !isObject(obj2)) {
        // If either is not an object, return obj2 as it takes precedence
        return obj2 || obj1;
    }
    var result = _extends({}, obj1); // Start with all properties from obj1
    for(var key in obj2){
        if (isObject(obj2[key]) && key in obj1) {
            // Recursively merge if both properties are objects
            result[key] = mergeObjects(obj1[key], obj2[key]);
        } else {
            // Set to obj2's property if not both objects or key not in obj1
            result[key] = obj2[key];
        }
    }
    return result;
}
export { stringifyAndCompare, mergeObjects };
